import { ReactNode, useState, useEffect } from 'react';
import LayoutWithSidebar from '@quicktools/shared-components/components/layout/LayoutWithSidebar';
import NextHead from '@quicktools/shared-components/components/common/NextHead';
import IconMenu from '@picsart/icons/IconMenu';
import { useTranslation } from 'react-i18next';
import { GoogleAd, useShowAd } from '@quicktools/shared-components/components/GoogleAd';
import {
  GOOGLE_AD_MANAGER_QT_LEADER_BOARD_MOBILE,
  GOOGLE_AD_MANAGER_QT_LEADER_BOARD_WEB,
} from '@quicktools/shared-components/services/constants';

import { initializeLocalStorage } from '../../utils/common/localStorage';
import EditorSidebar from '../EditorPage/EditorSidebar';
import Header from '../EditorPage/Header';
import MobileNavigation from '../EditorPage/MobileNavigation';
import { MAIN_CONTENT_ID } from '../../constants';

import useStyles from './styles';

type LayoutProps = {
  children: ReactNode;
  category: number;
  metaTitleKey: string;
  metaDescriptionKey: string;
  canonicalPath: string;
  hasRawTitle?: boolean;
};

function Layout({
  children,
  metaTitleKey,
  metaDescriptionKey,
  canonicalPath,
  hasRawTitle,
  category,
}: LayoutProps) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [showMenu, setShowMenu] = useState(false);
  const handleToggleMenu = () => {
    setShowMenu((prev) => !prev);
  };
  const { showDesktopAd, showMobileAd } = useShowAd();

  useEffect(() => {
    initializeLocalStorage();
  }, []);

  return (
    <>
      <NextHead
        noIndex
        title={t(metaTitleKey)}
        hasRawTitle={hasRawTitle}
        canonicalPath={canonicalPath}
        description={t(metaDescriptionKey)}
      />

      <LayoutWithSidebar
        mainClassName={classes.main}
        leftSidebarClassName={classes.sidebar}
        headerClassName={classes.header}
        header={
          <div className={classes.headerContainer}>
            <div>
              <MobileNavigation
                selectedCategory={category}
                handleToggleMenu={handleToggleMenu}
                isVisible={showMenu}
              />

              <Header icon={IconMenu} handleToggleMenu={handleToggleMenu} category={category} />
            </div>
          </div>
        }
        main={
          <div id={MAIN_CONTENT_ID}>
            {showDesktopAd && (
              <GoogleAd
                id={GOOGLE_AD_MANAGER_QT_LEADER_BOARD_WEB}
                className={classes.topAdDesktop}
              />
            )}

            {showMobileAd && (
              <GoogleAd
                id={GOOGLE_AD_MANAGER_QT_LEADER_BOARD_MOBILE}
                className={classes.topAdMobile}
              />
            )}

            <div className={classes.content}>{children}</div>
          </div>
        }
        leftSidebar={<EditorSidebar />}
      />
    </>
  );
}

export default Layout;
